import React, { useState } from "react";
import { DRIVER_PERKS, IMAGES } from "../mock";
import { Reveal } from "../hooks/useReveal";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function DriverSection() {
  const [form, setForm] = useState({ name: "", phone: "", city: "Lagos" });
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || form.phone.trim().length < 7) {
      toast.error("Please enter your name and a valid phone number.");
      return;
    }
    const list = JSON.parse(localStorage.getItem("id_drivers") || "[]");
    list.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem("id_drivers", JSON.stringify(list));
    setDone(true);
    toast.success("You're on the driver list!", { description: "We'll reach out with next steps before launch." });
  };

  return (
    <section id="drive" className="relative py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 bg-[#2fd645]/15 blur-3xl rounded-full" />
              <img
                src={IMAGES.driverMan}
                alt="InstantDrive driver partner"
                className="relative rounded-3xl border border-white/10 object-cover w-full h-[460px]"
              />
              <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-black/60 backdrop-blur-md border border-white/10 p-4 flex items-center justify-between">
                <div>
                  <div className="text-xs text-white/60">Weekly earnings potential</div>
                  <div className="font-display font-extrabold text-2xl text-[#2fd645]">₦180,000+</div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-white/60">Instant payouts</div>
                  <div className="font-display font-extrabold text-2xl text-white">Daily</div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">Drive &amp; earn</span>
            <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
              Turn your car into income
            </h2>
            <p className="mt-4 text-white/60 text-lg">
              Join InstantDrive as a partner and earn on your own schedule with
              the fairest commission in Nigeria and instant daily payouts.
            </p>

            <div className="mt-6 rounded-2xl border border-[#2fd645]/40 bg-[#2fd645]/10 p-5 flex items-center gap-5">
              <div className="text-center">
                <div className="font-display font-extrabold text-4xl text-[#2fd645] leading-none">92.5%</div>
                <div className="mt-1 text-xs uppercase tracking-wider text-white/60">You keep</div>
              </div>
              <div className="h-12 w-px bg-white/15" />
              <div>
                <div className="font-semibold text-white">Only 7.5% commission</div>
                <div className="text-sm text-white/65">
                  Drivers keep 92.5% of every fare (before tax) — paid out daily.
                </div>
              </div>
            </div>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {DRIVER_PERKS.map((p) => {
                const Icon = p.icon;
                return (
                  <div key={p.title} className="flex gap-3">
                    <div className="h-10 w-10 shrink-0 rounded-xl bg-[#2fd645]/12 border border-[#2fd645]/25 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-[#2fd645]" />
                    </div>
                    <div>
                      <div className="font-semibold text-white">{p.title}</div>
                      <div className="text-sm text-white/55">{p.text}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            {done ? (
              <div className="mt-8 flex items-center gap-3 rounded-2xl border border-[#2fd645]/40 bg-[#2fd645]/10 p-5">
                <CheckCircle2 className="h-6 w-6 text-[#2fd645]" />
                <p className="text-white/85">Thanks {form.name.split(" ")[0]}! You&apos;re on the driver waitlist for {form.city}.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="mt-8 grid sm:grid-cols-[1fr_1fr_auto] gap-3">
                <Input
                  placeholder="Full name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="h-12 bg-[#0e1311] border-white/15 text-white placeholder:text-white/40 focus-visible:ring-[#2fd645]"
                />
                <Input
                  placeholder="Phone number"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className="h-12 bg-[#0e1311] border-white/15 text-white placeholder:text-white/40 focus-visible:ring-[#2fd645]"
                />
                <Button type="submit" className="h-12 px-6 bg-[#2fd645] text-[#06210b] font-bold hover:bg-[#46ff5c] rounded-xl">
                  Become a driver
                </Button>
              </form>
            )}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
